import get from 'lodash/get';

const optionStatus = {
    pending: 'En attente',
    accepted: 'Acceptée',
    refused: 'Refusée',
    canceled: 'Annulée',
    outdated: 'Périmée',
    waiting: 'Att Ret Prom.'
};

function formatOptionStatus(value: string) {
    return get(optionStatus, value, value);
}

export { optionStatus, formatOptionStatus };
